export function getdata() {
  return {
    searchlist: [
      {
        prop: 'companyId',
        label: '公司',
        type: 'select',
        selectval: []
      },
      {
        prop: 'shuibId',
        label: '税表名称',
        type: 'select',
        selectval: []
      },
      {
        prop: 'shenbq',
        label: '申报期',
        type: 'datemonth',
        valueformat: 'yyyyMM'
      },
      {
        prop: 'status',
        label: '状态',
        type: 'select',
        selectval: [
          { label: '失败', value: '0' },
          { label: '成功', value: '1' },
          { label: '待执行', value: '2' }
        ]
      }
    ],
    searchdata: {
      companyId: '',
      shuibId: '',
      shenbq: '',
      status: ''
    },
    headData: [
      { title: '公司名称', prop: 'companyId', width: 180, custom: true },
      { title: '税表名称', prop: 'shuibId', width: 180, custom: true },
      { title: '申报期', prop: 'cank2', width: 100 },
      { title: '状态', prop: 'status', width: 90, custom: true },
      { title: '请求参数', prop: 'paramJson', width: 260, custom: true },
      { title: '响应结果', prop: 'result', width: 260, custom: true },
      { title: '创建人', prop: 'createBy', width: 100 },
      { title: '创建时间', prop: 'createTime', width: 160 },
      { title: '更新时间', prop: 'updateTime', width: 160 }
    ],
    pagination: {
      pageNum: 1,
      pageSize: 50,
      total: 0,
      paginationkey: 0
    }
  };
}
